module.exports = __webpack_public_path__ + "media/images/category/travel-515e82cbd72f63cd97deb12684dd6bc0.jpg";